'use client';
import * as React from 'react';
import { ThemeContext } from '../Theme/index.js';

var TextareaTheme;
(function (TextareaTheme) {
    TextareaTheme["ACSMARINE"] = "acsm";
    TextareaTheme["ALLIEDCONTAINER2"] = "acem2";
})(TextareaTheme || (TextareaTheme = {}));
var themes = new Map();
var defaultTheme = new Map();
defaultTheme.set("", "w-full p-2 border rounded outline outline-1 outline-slate-100");
defaultTheme.set("disabled-true", "cursor-not-allowed");
var acsmTheme = new Map();
acsmTheme.set("", "w-full p-2 border-b border-black placeholder:text-acsm-red font-verdana sm:!font-poppins");
acsmTheme.set("disabled-true", "cursor-not-allowed");
var acem2Theme = new Map();
acem2Theme.set("", "w-full p-2 border rounded outline outline-1 outline-acem2-asphalt");
acem2Theme.set("disabled-true", "cursor-not-allowed");
themes.set("", defaultTheme);
themes.set(TextareaTheme.ACSMARINE, acsmTheme);
themes.set(TextareaTheme.ALLIEDCONTAINER2, acem2Theme);
var TextareaStyle = /** @class */ (function () {
    function TextareaStyle() {
        this.theme = "";
        this.disabled = false;
        this.appendedClassNames = "";
        this.elementClassNames = "";
    }
    TextareaStyle.prototype.buildElement = function () {
        var style = undefined;
        if (this.elementClassNames) {
            return this.elementClassNames;
        }
        var theme = themes.get(this.theme);
        if (!theme) {
            return style;
        }
        if (theme.has("")) {
            style = theme.get("");
        }
        if (theme.has("disabled-".concat(this.disabled))) {
            style += " " + theme.get("disabled-".concat(this.disabled));
        }
        if (this.appendedClassNames && this.appendedClassNames !== "") {
            style += " " + this.appendedClassNames;
        }
        return style;
    };
    TextareaStyle.prototype.setTheme = function (theme) {
        this.theme = theme;
        return this;
    };
    TextareaStyle.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        return this;
    };
    TextareaStyle.prototype.setAppendedClassNames = function (appendedClassNames) {
        this.appendedClassNames = appendedClassNames;
        return this;
    };
    TextareaStyle.prototype.setElementClassNames = function (elementClassNames) {
        this.elementClassNames = elementClassNames;
        return this;
    };
    return TextareaStyle;
}());

var styleBuilder = new TextareaStyle();
function Textarea(props) {
    var themeCtx = React.useContext(ThemeContext);
    var _a = props.required, required = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.readOnly, readOnly = _c === void 0 ? false : _c, className = props.className, appendClassNames = props.appendClassNames, _d = props.rows, rows = _d === void 0 ? 5 : _d, cols = props.cols;
    var _e = props.theme, theme = _e === void 0 ? themeCtx.theme || "" : _e;
    if (!themes.has(theme)) {
        theme = "";
    }
    styleBuilder
        .setTheme(theme)
        .setElementClassNames(className)
        .setAppendedClassNames(appendClassNames)
        .setDisabled(disabled);
    var elementClassName = styleBuilder.buildElement();
    var handleInput = function (e) {
        props.onInput && props.onInput(e);
    };
    var handleChange = function (e) {
        props.onChange && props.onChange(e);
    };
    var handleBlur = function (e) {
        props.onBlur && props.onBlur(e);
    };
    return (React.createElement("textarea", { id: props.id, name: props.name, className: elementClassName, rows: rows, cols: cols, placeholder: props.placeholder, defaultValue: props.defaultValue, value: props.value, required: required, disabled: disabled, readOnly: readOnly, onInput: handleInput, onChange: handleChange, onBlur: handleBlur }, props.children));
}

export { Textarea };
